import Input from "../../Input"

const DynamicChannel = ({ index, values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل اتومات {index + 1}</h6>
            <div className="font-sans">
                <Input
                    type="number"
                    label="ایدی چنل *"
                    name={`dynamicChannels-${index}-id`}
                    placeholder="ChannelID"
                    options={serverData?.channelList}
                    autoComplete="off"
                    defaultValue={values?.id}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    name={`dynamicChannels-${index}-format`}
                    label="فرمت *"
                    placeholder="Format"
                    defaultValue={values?.format}
                    autoComplete="off"
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <Input
                    type="number"
                    name={`dynamicChannels-${index}-iconId`}
                    label="ایدی ایکون"
                    placeholder="IconId"
                    options={serverData?.iconList}
                    defaultValue={values?.iconId}
                    autoComplete="off"
                    dir="ltr"
                />
            </div>
            <div className="grid grid-cols-4 gap-5 mt-2">
                <div className="">
                    <Input
                        type="number"
                        label="حداقل چنل خالی *"
                        name={`dynamicChannels-${index}-minChannels`}
                        autoComplete="off"
                        defaultValue={values?.minChannels ? values.minChannels : 1}
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        label="حداکثر چنل ها *"
                        name={`dynamicChannels-${index}-maxChannels`}
                        placeholder="برای نامحدود صفر بزارین"
                        autoComplete="off"
                        defaultValue={values?.maxChannels || 0}
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        label="اسلات هر چنل *"
                        name={`dynamicChannels-${index}-maxClients`}
                        placeholder="برای نامحدود صفر بزارین"
                        autoComplete="off"
                        defaultValue={values?.maxClients || 0}
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        label="پرمیشن جوین"
                        name={`dynamicChannels-${index}-joinPower`}
                        placeholder="برای نامحدود صفر بزارین"
                        autoComplete="off"
                        defaultValue={values?.joinPower || 0}
                        dir="ltr"
                    />
                </div>
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%s: شاخص چنل</div>
                </div>
            </div>
        </div>
    )
}

export default DynamicChannel
